/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_DownloadedInputs */

const en_us2_share_downloaded = /** @type {(inputs: Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image saved to downloads.`)
};

const pt_br2_share_downloaded = /** @type {(inputs: Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagem salva nos downloads.`)
};

const es_419_share_downloaded = /** @type {(inputs: Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen guardada en descargas.`)
};

const pt_pt2_share_downloaded = /** @type {(inputs: Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagem guardada nas transferências.`)
};

const fr_fr2_share_downloaded = /** @type {(inputs: Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image enregistrée dans les téléchargements.`)
};

const de_de2_share_downloaded = /** @type {(inputs: Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild in Downloads gespeichert.`)
};

const it_it2_share_downloaded = /** @type {(inputs: Share_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immagine salvata nei download.`)
};

/**
* | output |
* | --- |
* | "Image saved to downloads." |
*
* @param {Share_DownloadedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_downloaded = /** @type {((inputs?: Share_DownloadedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_DownloadedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_downloaded(inputs)
	if (locale === "es-419") return es_419_share_downloaded(inputs)
	if (locale === "pt-PT") return pt_pt2_share_downloaded(inputs)
	if (locale === "fr-FR") return fr_fr2_share_downloaded(inputs)
	if (locale === "de-DE") return de_de2_share_downloaded(inputs)
	if (locale === "it-IT") return it_it2_share_downloaded(inputs)
	return en_us2_share_downloaded(inputs)
});
export { share_downloaded as "share.downloaded" }